import moment from "moment";
import customerApi from "~/api/customer";

export default {
  data() {
    return {
      customer: null,
      partner: null,
    };
  },
  async mounted() {
    const response = await customerApi.findFamily(this.customer_id);

    this.customer = response.data?.main?.data;
    this.partner = response.data?.partner?.data;
  },
  methods: {
    setMaximumMortgageState(window) {
      window.setState("has_partner", this.partner !== null);
      window.setApplicant(
        "day_of_birth",
        moment(this.customer.date_of_birth).format("DD")
      );
      window.setApplicant(
        "month_of_birth",
        moment(this.customer.date_of_birth).format("MM")
      );
      window.setApplicant(
        "year_of_birth",
        moment(this.customer.date_of_birth).format("YYYY")
      );

      if (this.partner) {
        window.setPartner(
          "day_of_birth",
          moment(this.partner.date_of_birth).format("DD")
        );
        window.setPartner(
          "month_of_birth",
          moment(this.partner.date_of_birth).format("MM")
        );
        window.setPartner(
          "year_of_birth",
          moment(this.partner.date_of_birth).format("YYYY")
        );
      }

      window.setState("first_name", this.customer.initials);
      window.setState("insertion", this.customer.suffix);
      window.setState("last_name", this.customer.last_name);
      window.setState("email", this.customer.email_address);
      window.setState(
        "phone_number",
        this.customer.mobile ?? this.customer.phone ?? this.customer.phone_work
      );

      window.setApplicant("employment", "salary");
      window.setApplicant("contract_type", "fixed");
      window.setApplicant("income", Math.floor(this.customer.salary / 12.96));
      window.setApplicant("has_holiday_allowance", false);
      window.setApplicant("has_extra_payment", false);

      if (this.partner) {
        if (this.partner.salary > 0) {
          window.setPartner("employment", "salary");
          window.setPartner("contract_type", "fixed");
          window.setPartner("income", Math.floor(this.partner.salary / 12.96));
          window.setPartner("has_holiday_allowance", false);
          window.setPartner("has_extra_payment", false);
        } else {
          window.setPartner("employment", "none");
        }
      }
    },
    setInterestListState(window) {
      //
    },
    setSustainabilityState(window) {
      //
    },
  },
};
